import { IconSVG } from '../types';

export const ChevronRight = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      style={style}
      viewBox="0 0 24 24"
    >
      <path d="M12.6 12 8.7 8.1a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275l4.6 4.6c.1.1.17.208.212.325.042.117.063.242.063.375s-.021.258-.063.375a.877.877 0 0 1-.212.325l-4.6 4.6a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7l3.9-3.9Z" />
    </svg>
  );
};
